module.exports = require("net");


//////////////////
// WEBPACK FOOTER
// external "net"
// module id = 260
// module chunks = 1